
import { Component, Emit, InjectReactive, Prop, Vue } from 'vue-property-decorator'

import ShoppingCartSvg from '@/components/ShoppingCartSvg.vue';
import { OrderSteps, Views } from '@/enums';
import Basket from '@/store/modules/basket';
import { hideCMSContent } from '@/utils/global.util';

@Component({
  components: {
    ShoppingCartSvg,
  }
})
export default class Cart extends Vue {
  @Prop({ type: String, default: 'primary' }) variant: string;
  @Prop({ type: Number, default: 25 }) height: number;
  @Prop({ type: Number, default: 25 }) width: number;
  @InjectReactive() isMobile!: boolean;
  @InjectReactive('reviewDrawerOpen') reviewDrawerOpen!: boolean;

  @Emit('toggle-review-drawer')
  toggleReviewDrawer(ev) {
    return ev;
  }

  goToCart() {
    if (![Views.ORDER_SUMMARY, Views.CHECKOUT, Views.ORDER_CONFIRMATION].includes(this.$route.name as Views)) {
      if (this.isMobile) {
        const menu = document.getElementById('mobileMenu');
        if (menu && menu.classList.contains('opacity-100')) {
          const button = document.getElementById('mobile-menu-toggle');
          if (button) {
            button.click();
          }
        }

        hideCMSContent();

        this.$router.push({
          name: 'OrderSummary',
          params: {
            ...this.$route.params
          },
        });
      } else {
        this.toggleReviewDrawer(false);
      }
    }
  }

  get basketCount() {
    return Basket.current?.products?.reduce((acc, product: BasketProduct) => acc + product.quantity, 0);
  }

  get classes() {
    return {
      empty: !this.basketCount,
      'in-progress': !!this.basketCount,
    }
  }

  get orderSteps() {
    return Object.values(OrderSteps || {});
  }
}
